import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core"
import { Observable } from "rxjs";
import { Page } from "src/app/core/common/http/page.model";
import { environment } from "src/environments/environment"
import { ICdc } from "./cdc.model";

@Injectable({
    providedIn: 'root'
})
export class CdcService {
    private readonly httpClient = inject(HttpClient); 
    private readonly baseUrl = environment.backend.baseUrl;

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Basic dGVzdDp0ZXN0',
        }),
    };

    public getListOfCdc(): Observable<HttpResponse<Page<ICdc[]>>> {
        const requestURL = `${this.baseUrl}/request/cdcs`;
        return this.httpClient
            .get<HttpResponse<Page<ICdc[]>>>(requestURL, {
                headers: this.httpOptions.headers
            });
    }
}












